import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(user-mgmt)/project/$project/user-mgmt/')({
  beforeLoad: () => { throw redirect({ to: '/project/$project/user-mgmt/users', params: p => ({ project: p.project ?? '' }) }); },
});
